import { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { Tabs, Tab, Box, Stack, Pagination } from "@mui/material";
import Search from "../../../../components/searchField";
import { theme } from "../../../../theme";
import DivSpinner from "../../../../components/divSpinner";
import { fetchExpiredAndExpiring } from "../service";
import Table from "./Table";


const TabPanel = ({ children, value, index }) => {
    return (
        <div role="tabpanel" hidden={value !== index} style={{ height: `550px`, overflowY: "scroll" }}>
            {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
        </div>
    );
};

const DocumentsTypeTabs = ({ selectedTab, setSelectedTab, page, setPage, filter }) => {

    const [list, setList] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);

    const [searchText, setSearchText] = useState("");

    const tabs = useMemo(() => [
        "CERTIFICATES", "DOCUMENTS"
    ], []);

    useEffect(() => {
        console.log("🚀 ~ searchText:", searchText)
    }, [searchText]);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await fetchExpiredAndExpiring({ 
                document_type: selectedTab === 0 ? "documents" : "personal", 
                filter, 
                page_number: page
            });
            setList(response?.list || []);
            setTotalPages(response?.total_pages || 1);
        } catch (error) {
            console.error("Error fetching data:", error);
            setList([]);
        } finally {
            setLoading(false);
        }
    }, [selectedTab, filter, page]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
            <div className="p-3">
                <Search
                    onSearch={setSearchText}
                    is_filter={false}
                    fullWidth={false}
                />
            </div>
            <Tabs
                value={selectedTab}
                onChange={(e, newValue) => setSelectedTab(newValue)}
                variant="fullWidth"
                textColor="inherit"
                TabIndicatorProps={{ style: { backgroundColor: theme.main_code } }}
                sx={{
                    backgroundColor: "#f0f0f0",
                }}
            >
                {tabs.map((label, index) => (
                    <Tab
                        key={index}
                        label={label}
                        sx={{
                            color: selectedTab === index ? theme.main_code : "gray",
                            fontWeight: selectedTab === index ? "bold" : "bold",
                            "&:hover": { color: theme.main_code },
                        }}
                    />
                ))}
            </Tabs>

            <TabPanel value={selectedTab} index={selectedTab}>
                {loading ? (
                    <div style={{ height: `${window.innerHeight - 350}px` }}>
                        <DivSpinner />
                    </div>
                ) : (
                    <Box sx={{ pb: 6 }}>
                        {/* {isMobile ? <JobMobile list={list} jobType={selectedTab} openCreateDispute={openCreateDispute}/> : <JobsTable list={list} jobType={selectedTab} openCreateDispute={openCreateDispute}/>} */}
                        <Table list={list} documentType={selectedTab === 0 ? "documents" : "personal"}/>
                    </Box>
                )}
            </TabPanel>

            {(!loading && list.length > 0) && (
                <Stack spacing={2} sx={{ alignItems: "center", mt: 2, pb: 4 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, newPage) => setPage(newPage)}
                        color={theme.main}
                    />
                </Stack>
            )}

            {/* <CreateDispute is_show_dispute_view={isCreateDispute.open} closeView={closeCreateDispute} job_id={isCreateDispute.jobId}/> */}
        </Box>
    );
};

const DocumentsTypeTabsWrapper = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type');
    
    const [selectedTab, setSelectedTab] = useState(Number(type) || 0);
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState("default");

    useEffect(() => {
        setPage(1);
    }, [selectedTab]);

    return <DocumentsTypeTabs selectedTab={selectedTab} setSelectedTab={setSelectedTab} page={page} setPage={setPage} filter={filter} setFilter={setFilter}/>;
};

export default DocumentsTypeTabsWrapper;
